import React, { Component } from "react";

//Common Functions
import * as format from "../../../common/FormatFunctions";
import { BPMStatistics } from "../../Common/BPMChart";
import { DisplayType } from "../../Common/Statistics/ChartObjects";
import { ChartType } from "../../Common/Statistics/ChartObjects";
import * as pr from "../../../common/PrimeComponents";
import * as ChartHelper from "../../Statistics/ChartExamples";

//import "./CustomCSS/charts.css";
export class DashboardCoating extends Component {
  constructor() {
    super();
    this.state = {
      chartData: this.renderPieData(),
      loop: "Iteration 1"
    };
  }
  componentDidMount = () => {
    this.initialDataRender();
    this.interval = setInterval(() => this.refresh(), 10000);
  };

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  initialDataRender = async () => {
    await this.setPageData();
  };

  setPageData = async () => {
    this.setState({ loading: true });

    this.setState({ loading: false });
  };

  refresh = () => {
    this.setState({ loading: true });
    console.log("Refreshing...");
    console.log(this.state);
    console.log(this.state.loop);
    var localRefreshState = format.deepCopy(this.state.loop);
    if (localRefreshState === "Iteration 1") {
      console.log("Changing Iteration 1 --> 2");
      this.setState({
        chartData: this.renderPieData(),

        loop: "Iteration 2"
      });
    }

    if (localRefreshState === "Iteration 2") {
      console.log("Changing Iteration 2 --> 3");
      this.setState({
        chartData: this.renderPieDataIt2(),

        loop: "Iteration 1"
      });
    }

    this.setState({ loading: false });
  };
  // #endregion

  // #region View
  render() {
    return (
      <pr.Panel header="Coating" style={{ height: "100%" }}>
        {this.getChart(
          DisplayType.CHART,
          ChartType.PIE,
          this.state.chartData,
          ChartHelper.renderPieOptions()
        )}
      </pr.Panel>
    );
  }

  getChartAndTable = (displayType, chartType, chartData, chartOptions) => {
    return (
      <div className="ui-g-12 card">
        <BPMStatistics
          displayType={displayType}
          chartType={chartType}
          chartData={chartData}
          chartOptions={chartOptions}
        ></BPMStatistics>
        <BPMStatistics
          displayType={DisplayType.TABLE}
          tableData={ChartHelper.renderProductLeadTimeDataPivot()}
        />
      </div>
    );
  };

  getChart = (displayType, chartType, chartData, chartOptions) => {
    return (
      <BPMStatistics
        displayType={displayType}
        chartType={chartType}
        chartData={chartData}
        chartOptions={chartOptions}
      />
    );
  };
  renderPieData = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Jobs", type: "string", id: null },
      { label: "In Progress", type: "number", id: null }
    ];
    chartDataBean.rows.push(["Complete", 67]);
    chartDataBean.rows.push(["Incomplete", 33]);

    return chartDataBean;
  };
  renderPieDataIt2 = () => {
    var chartDataBean = {};

    chartDataBean.rows = [];
    chartDataBean.columns = [];

    chartDataBean.columns = [
      { label: "Jobs", type: "string", id: null },
      { label: "In Progress", type: "number", id: null }
    ];
    chartDataBean.rows.push(["Complete", 72]);
    chartDataBean.rows.push(["Incomplete", 28]);

    return chartDataBean;
  };
  // #endregion
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/UI/DashboardCoating.js